'use client'

import React, { useRef } from "react"
import { getAsServerMediaUrl, getMediaUrl } from "@/services/pathname"
import { v4 as uuid } from 'uuid'
import { Lightbox } from "./Lightbox"
import Image from "next/image"

/**
 * Rendered width of an image in the grid, see .galleryGrid.galleryN in custom.scss :
 * one image takes the whole container, otherwise the first one (and the second one of 4, spanning 2 columns) about half of it,
 * the last two of 4 about a quarter
 */
function getSizes(count: number, index: number) {
    if (count === 1) {
        return '(max-width: 1320px) 100vw, 1320px'
    }
    if (count < 4 || index < 2) {
        return '(max-width: 576px) 100vw, (max-width: 1320px) 50vw, 690px'
    }
    return '(max-width: 576px) 100vw, (max-width: 992px) 50vw, 320px'
}

type GalleryProps = {
    id?: string,
    medias: Media[],
}

export default function Gallery({
    id = 'gallery',
    medias
}: GalleryProps) {

    /*const id = useRef<string>('g' + uuid())
    console.log(id.current)*/

    if (medias.length === 0) return <></>

    return (
        <>
            <div id={id} className={"galleryGrid -type-1 " + (medias.length > 3 ? "gallery4" : ("gallery" + medias.length)) + " relative"}>
                {medias.slice(0, 4).map((media, indexMedia) => {
                    return (
                        <React.Fragment key={"media-" + indexMedia}>
                            <div className="galleryGrid__item">
                                <a href={getMediaUrl(media.url)} className={"gallery-a js-gallery-" + id} data-gallery="gallery2" style={{height: '100%', width: '100%'}}>
                                    {media.mimeType.indexOf('image/') === 0 &&
                                        <>
                                            <Image
                                                src={getAsServerMediaUrl(media.url)}
                                                alt="image"
                                                width={media.metadata.width}
                                                height={media.metadata.height}
                                                sizes={getSizes(medias.length, indexMedia)}
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                preload={indexMedia === 0}
                                            />
                                            {/*<img src={getMediaUrl(media.url)} alt="image" loading="lazy" />*/}
                                        </>
                                    }
                                    {media.mimeType.indexOf('video/') === 0 &&
                                        <video className="hero-video" controls={true} autoPlay={true} muted={false} loop={true} poster={getMediaUrl(media.url) + '/fallback.jpg'}>
                                            <source src={getMediaUrl(media.url)} type={media.mimeType} />
                                        </video>
                                    }
                                </a>
                            </div>
                        </React.Fragment>
                    )
                })}
                {medias.length > 1 &&
                    <div className={"absolute col-12 z-2 px-20 py-20 d-flex justify-end items-end" + (medias.length < 5 ? ' d-sm-none' : '')}>
                        <a className="button-secondary glightbox-open">
                            <i className="fi fi-rr-eye" />
                            Afficher toutes les photos
                        </a>
                        {medias.slice(4).map((media, indexMedia) => {
                            return (
                                <React.Fragment key={"media-" + indexMedia}>
                                    <a href={getMediaUrl(media.url)} className={"js-gallery-" + id} data-gallery="gallery2" />
                                </React.Fragment>
                            )
                        })}

                    </div>
                }
                <Lightbox
                    selector={'.js-gallery-' + id}
                    openTriggerElementSelector={'#' + id + ' .glightbox-open'}
                />
            </div>
        </>
    )
}